<template>
  <div class="gp-main-body-content">
    <!-- <div class="my-2"></div> -->
    <div class="gp-settings-page">
      <div class="gp-settings-page__sidebar">
        <ul class="gp-settings-page__sidebar-nav">
          <li v-if="!isGemPagesV7">
            <a href="javascript:void(0)" :class="{ active: activeMenu === 'store_settings' }" @click="scrollTo('store_settings')">{{ $t("storeSettings.headerTitle") }}</a>
          </li>
          <li>
            <a href="javascript:void(0)" :class="{ active: activeMenu === 'plan_information' }" @click="scrollTo('plan_information')">{{ $t("accountSettings.plan.title") }}</a>
          </li>
          <li>
            <a href="javascript:void(0)" :class="{ active: activeMenu === 'profile_settings' }" @click="scrollTo('profile_settings')">{{ $t("accountSettings.profile.title") }}</a>
          </li>
          <li>
            <a href="javascript:void(0)" :class="{ active: activeMenu === 'email_notification' }" @click="scrollTo('email_notification')">{{ $t("accountSettings.email.title") }}</a>
          </li>
          <li>
            <a href="javascript:void(0)" :class="{ active: activeMenu === 'data_privacy' }" @click="scrollTo('data_privacy')">{{ $t("accountSettings.dataPrivacy.title") }}</a>
          </li>
          <li v-if="!isGemPagesV7">
            <a href="javascript:void(0)" :class="{ active: activeMenu === 'add_code_to_theme' }" @click="scrollTo('add_code_to_theme')">
              {{ $t("accountSettings.addCodeToTheme.title") }}
            </a>
          </li>
        </ul>
      </div>
      <div class="gp-settings-page__content">
        <section id="store_settings" class="mb-4" v-if="!isGemPagesV7">
          <div class="gp-card">
            <div class="gp-card__head">
              <h3 class="gp-card__head-title">{{ $t("storeSettings.headerTitle") }}</h3>
            </div>
            <div class="gp-card__body">
              <form @submit.prevent="updateStoreSettings(true)">
                <div class="form-group" v-if="shopInfo.passwordEnabled">
                  <label class="label d-flex align-items-center mb-2">
                    <span>{{ $t("storeSettings.storefront") }}</span>
                    <div class="pr-1 ml-1 mr-1 d-flex" v-popover:tooltip.right="$t('storeSettings.storefrontTooltip')">
                      <i class="icon icon-help tip typo-icon-14 text-light-disabled"></i>
                    </div>
                  </label>
                  <div class="form-group password-field">
                    <div class="d-flex">
                      <div class="password-field-input">
                        <input class="input-field" :type="showPassword ? 'text' : 'password'" autocomplete="new-password" placeholder="Input your Shopify store password" v-model="storePassword" />
                        <div class="toggle-view" @click="showPassword = !showPassword" :title="showPassword ? $t('storeSettings.hidePwd') : $t('storeSettings.showPwd')">
                          <i class="icon icon-view" v-if="!showPassword"></i>
                          <i class="icon icon-view-off" v-else></i>
                        </div>
                      </div>
                      <div class="password-field-btn ml-1">
                        <ProcessButton class="ml-0" :disabled="changePassword" :status.sync="statusLoading" type="submit" default="btn-secondary2">
                          <template #loading>{{ $t("generals.save") }}</template>
                          <template #success>{{ $t("generals.save") }} {{ $t("generals.success") }}</template>
                          <template #error>{{ $t("generals.save") }} {{ $t("generals.fail") }}</template>
                          <template #default>{{ $t("generals.save") }} {{ $tc("generals.password") }}</template>
                        </ProcessButton>
                      </div>
                    </div>
                  </div>
                  <p class="typo-body4 typo-regular typo-italic text-danger mt-1" v-if="wrongPassword" v-html="$t('storeSettings.wrongPass', { domain: shopInfo.shopifyDomain })" />
                  <p class="typo-body4 typo-regular text-light-low  mt-1 pwd" v-html="$t('storeSettings.storePasswordFoot', { domain: shopInfo.shopifyDomain })"></p>
                </div>
                <div class="gt-line" v-if="shopInfo.passwordEnabled && !isGemPagesV7"></div>
                <div v-if="!isGemPagesV7">
                  <div class="">
                    <p class="typo-button14 typo-medium text-light-high">{{ $t("accountSettings.analytics.title") }}</p>
                  </div>
                  <form @submit.prevent="updateInfo('analytics')">
                    <WebAnalyticTools v-model="analytics" @input="logValue" :highlight="highlight" />
                  </form>
                </div>
                <div v-if="!isGemPagesV7" class="gt-line"></div>
                <div class="setting other-settings">
                  <div class="">
                    <p class="typo-button14 typo-medium text-light-high">{{ $t("storeSettings.other.title") }}</p>
                  </div>
                  <!-- productSchema -->
                  <div class="mt-2" v-if="!isGemPagesV7">
                    <Switcher v-model="storeSettings.productSchema" :padding="'p-0'" @input="updateStoreSettings(false)">
                      <template #title>{{ $t("storeSettings.other.productSchema.title") }}</template>
                      <template #subtitle>{{ $t("storeSettings.other.productSchema.subtitle") }}</template>
                    </Switcher>
                  </div>
                  <!-- themeScript -->
                  <div class="mt-2">
                    <Switcher v-model="storeSettings.themeScript" :padding="'p-0'" @input="updateStoreSettings(false)">
                      <template #title>{{ $t("storeSettings.other.themeScript.title") }}</template>
                      <template #subtitle>{{ $t("storeSettings.other.themeScript.subtitle") }}</template>
                    </Switcher>
                  </div>
                  <!-- preloadScript -->
                  <div class="mt-2" v-if="!isGemPagesV7">
                    <Switcher v-model="storeSettings.preloadScript" :padding="'p-0'" @input="updateStoreSettings(false)">
                      <template #title>{{ $t("storeSettings.other.preloadScript.title") }}</template>
                      <template #subtitle>{{ $t("storeSettings.other.preloadScript.subtitle") }}</template>
                    </Switcher>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>

        <section id="plan_information" class="mb-4">
          <div class="gp-card plan-info">
            <div class="gp-card__head">
              <h3 class="gp-card__head-title">{{ $t("accountSettings.plan.title") }}</h3>
            </div>
            <div class="gp-card__body">
              <div class="block d-flex align-items-center">
                <div class="icon mr-2">
                  <img class="starter" style="width: 24px;" v-if="shopInfo.plan == PLAN_NO.STARTER" :src="publicPath + require('@/core/assets/pricing/starter_plan_icon.svg')" />
                  <img class="trial" style="width: 24px;" v-if="shopInfo.plan == PLAN_NO.TRIAL || shopInfo.plan == PLAN_NO.TRIAL2022" :src="publicPath + require('@/core/assets/pricing/trial_plan_icon.svg')" />
                  <img class="build" style="width: 24px;" v-if="shopInfo.plan == PLAN_NO.BUILD || shopInfo.plan == PLAN_NO.PROFESSIONAL" :src="publicPath + require('@/core/assets/pricing/build_plan_icon.svg')" />
                  <img class="optimize" style="width: 24px;" v-if="shopInfo.plan == PLAN_NO.OPTIMIZE || shopInfo.plan == PLAN_NO.ADVANCED" :src="publicPath + require('@/core/assets/pricing/optimize_plan_icon.svg')" />
                  <img class="enterprise" style="width: 24px;" v-if="shopInfo.plan == PLAN_NO.ENTERPRISE" :src="publicPath + require('@/core/assets/pricing/enterprise_plan_icon.svg')" />
                </div>
                <div class="content">
                  <p class="typo-paragraph14 typo-medium text-lightmode">
                    <span
                      :class="{
                        professional: shopInfo.plan == PLAN_NO.BUILD || shopInfo.plan == PLAN_NO.PROFESSIONAL,
                        advanced: shopInfo.plan == PLAN_NO.OPTIMIZE || shopInfo.plan == PLAN_NO.ADVANCED
                      }"
                    >
                      {{
                        $t("generals.account.plan", {
                          type: PLAN_NAMES[shopInfo.plan] || shopPlan
                        })
                      }}
                    </span>
                  </p>
                  <p class="typo-paragraph14 typo-regular mt-1">
                    <span class="text-mono3 clickable" @click="goToUpgrade"> {{ $t("sidebar.seePlan") }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="profile_settings" class="mb-4">
          <div class="gp-card">
            <div class="gp-card__head">
              <h3 class="gp-card__head-title">{{ $t("accountSettings.profile.title") }}</h3>
            </div>
            <div class="gp-card__body">
              <div class="setting">
                <div class="form-group" v-if="shopInfo">
                  <Modal :hideExit="true" @cancel="closeModal" v-if="modalActive">
                    <template #header>
                      <p class="typo-title1">{{ $t("agency.modalDelete.titleUnlinkAgency") }}</p>
                    </template>
                    <template #default>
                      <template>
                        <p class="typo-body2 text-grey2">
                          {{ $t("agency.modalDelete.areYouSureUnlink") }}&nbsp; <span class="text-black1">“{{ shopInfo.agency && shopInfo.agency.name }}”</span> ?
                        </p>
                      </template>
                    </template>
                    <template #footer>
                      <div class="btn-group flex-row-reverse ">
                        <ProcessButton class="" :status.sync="unlinkStatus" @click="doUnlink" default="btn-danger">
                          <template #loading>{{ $t("generals.saving") }}</template>
                          <template #success>{{ $t("generals.unlinkAgencySuccess") }}</template>
                          <template #error>{{ $t("generals.unlinkAgencyFail") }}</template>
                          <template #default>{{ $t("generals.unlinkAgency") }}</template>
                        </ProcessButton>
                        <button class="btn btn-outline mr-1" @click="closeModal">{{ $t("generals.cancel") }}</button>
                      </div>
                    </template>
                  </Modal>
                </div>
              </div>
              <div class="row mb-2" v-if="shopInfo.hasAgency && !agencyLogged">
                <div class="col-12 col-md-9 col-lg-8 col-mlg-6">
                  <div class="row mb-1">
                    <div class="col-12">
                      <label class="label typo-button14 typo-medium text-light-high">{{ $t("accountSettings.partnership") }}</label>
                    </div>
                  </div>
                  <div class="row center align-items-center">
                    <div class="col-6 col-xs-6 col-sm-6">
                      <div class="shop-logo">
                        <img :src="shopInfo.agency.logo" alt v-if="shopInfo.agency && shopInfo.agency.logo" />
                        <img :src="publicPath + require('@/core/assets/agency-logo.svg')" alt v-else />
                      </div>
                    </div>
                    <div class="col-6 col-xs-6 col-sm-6 text-right">
                      <button class="align-items-center btn unlink-item btn-outline" type="button" @click="showModalUnlink">
                        <i class="icon icon-ungroup typo-icon-16 mr-1"></i>
                        <span>{{ $t("agency.unlink") }}</span>
                      </button>
                    </div>
                    <Modal :hideExit="true" @cancel="closeModal" v-if="modalActive">
                      <template #header>
                        <p class="typo-title1">{{ $t("agency.modalDelete.titleUnlinkAgency") }}</p>
                      </template>
                      <template #default>
                        <template>
                          <p class="typo-body2 text-grey2">
                            {{ $t("agency.modalDelete.areYouSureUnlink") }}&nbsp; <span class="text-black1">“{{ shopInfo.agency && shopInfo.agency.name }}”</span> ?
                          </p>
                        </template>
                      </template>
                      <template #footer>
                        <div class="btn-group flex-row-reverse ">
                          <ProcessButton class="" :status.sync="unlinkStatus" @click="doUnlink" default="btn-danger">
                            <template #loading>{{ $t("generals.saving") }}</template>
                            <template #success>{{ $t("generals.unlinkAgencySuccess") }}</template>
                            <template #error>{{ $t("generals.unlinkAgencyFail") }}</template>
                            <template #default>{{ $t("generals.unlinkAgency") }}</template>
                          </ProcessButton>
                          <button class="btn btn-outline mr-1" @click="closeModal">{{ $t("generals.cancel") }}</button>
                        </div>
                      </template>
                    </Modal>
                  </div>
                </div>
              </div>
              <form @submit.prevent="updateInfo">
                <div class="setting-block">
                  <div class="form-group">
                    <label class="label d-flex align-items-center">
                      <span>Profile Information</span>
                      <div class="pr-1 ml-1 mr-1 d-flex" v-popover:mytooltip.right="$t('accountSettings.changeInShopifyOnly')">
                        <i class="icon icon-help tip typo-icon-14 text-light-disabled"></i>
                      </div>
                    </label>
                    <div class="shop-info p-2">
                      <h3 class="typo-button14 typo-medium text-lightmode">{{ shopInfo.firstName + " " + shopInfo.lastName }}</h3>
                      <div class="typo-button14 text-lightmode mt-1">{{ email }}</div>
                    </div>
                  </div>
                  <div class="form-group mt-2">
                    <label class="label d-flex align-items-center">
                      <span>Shopify Domain</span>
                      <div class="pr-1 ml-1 mr-1 d-flex" v-popover:mytooltip.right="$t('accountSettings.changeInShopifyOnly')">
                        <i class="icon icon-help tip typo-icon-14 text-light-disabled"></i>
                      </div>
                    </label>
                    <div class="shop-info p-2">
                      <h3 class="typo-button14 typo-medium text-lightmode">{{ shopInfo.name }}</h3>
                      <a class="link typo-paragraph14 typo-regular mt-1 d-inline-block" target="_blank" :href="'https://' + shopInfo.shopifyDomain">
                        {{ shopInfo.shopifyDomain }}
                      </a>
                    </div>
                  </div>
                  <div class="gt-line"></div>
                  <div class="form-group mt-2" v-if="shopInfo.shareable">
                    <label class="label d-flex align-items-center">
                      <span>{{ $t("accountSettings.refID") }}</span>
                      <div class="pr-1 ml-1 mr-1 d-flex" v-popover:tooltip.right="$t('accountSettings.refIDToolTip')">
                        <i class="icon icon-help tip typo-icon-14 text-light-disabled"></i>
                      </div>
                    </label>
                    <input class="input-field" type="text" v-model="refID" placeholder="Eg: chris" @blur="updateInfo" />
                  </div>
                  <div class="form-group mt-2" v-if="!hideLanguage">
                    <label class="label">{{ $t("generals.language") }}</label>
                    <div>
                      <SelectLang v-model="lang" @input="changeLang" />
                    </div>
                  </div>
                  <Portal to="tooltips">
                    <transition name="fade">
                      <Tooltip name="mytooltip" :delay="800" :pointer="true" :width="'auto'" :maxWidth="'25%'" />
                    </transition>
                  </Portal>
                </div>
              </form>
            </div>
          </div>
        </section>

        <section id="email_notification" class="mb-4">
          <div class="gp-card">
            <div class="gp-card__head">
              <h3 class="gp-card__head-title">{{ $t("accountSettings.email.title") }}</h3>
            </div>
            <div class="gp-card__body">
              <form @submit.prevent="updateInfo('email')">
                <div class="email-tab">
                  <div>
                    <p class="typo-button14 typo-medium text-lightmode">{{ $t("accountSettings.email.subtitle") }}</p>
                  </div>

                  <div class="mt-2" v-if="shouldShowWarningBox">
                    <!-- Warning box -->
                    <div class="d-flex p-relative p-2 flex-grow-1 warn-info">
                      <i class="icon icon-warning typo-icon-16 mr-1 text-accent-yellow"></i>
                      <div class="flex-grow-1">
                        <h4 class="typo-paragraph12 typo-medium text-light-high">{{ $t("accountSettings.unsubscribeWarn.title") }}</h4>
                        <p class="typo-body4 typo-regular text-light-high mt-half">{{ $t("accountSettings.unsubscribeWarn.desc") }}</p>
                      </div>
                    </div>
                  </div>

                  <div>
                    <!-- theme -->
                    <div class="mt-2" v-if="!isGemPagesV7">
                      <Switcher v-model="settings.theme" :padding="'p-0'" @input="updateInfo('email')">
                        <template #title>{{ $t("accountSettings.email.theme.title") }}</template>
                        <template #subtitle>{{ $t("accountSettings.email.theme.subtitle") }}</template>
                      </Switcher>
                    </div>
                    <!-- newsletters -->
                    <div class="mt-2">
                      <Switcher v-model="settings.newsletters" :padding="'p-0'" @input="updateInfo('email')">
                        <template #title>{{ $t("accountSettings.email.newsletters.title") }}</template>
                        <template #subtitle>{{ $t("accountSettings.email.newsletters.subtitle") }}</template>
                      </Switcher>
                    </div>
                    <!-- update -->
                    <div class="mt-2">
                      <Switcher v-model="settings.updates" :padding="'p-0'" @input="updateInfo('email')">
                        <template #title>{{ $t("accountSettings.email.update.title") }}</template>
                        <template #subtitle>{{ $t("accountSettings.email.update.subtitle") }}</template>
                      </Switcher>
                    </div>
                    <!-- partners -->
                    <div class="mt-2">
                      <Switcher v-model="settings.partners" :padding="'p-0'" @input="updateInfo('email')">
                        <template #title>{{ $t("accountSettings.email.partners.title") }}</template>
                        <template #subtitle>{{ $t("accountSettings.email.partners.subtitle") }}</template>
                      </Switcher>
                    </div>
                    <!-- onboarding -->
                    <div class="mt-2">
                      <Switcher v-model="settings.onboarding" :padding="'p-0'" @input="updateInfo('email')">
                        <template #title>{{ $t("accountSettings.email.onboarding.title") }}</template>
                        <template #subtitle>{{ $t("accountSettings.email.onboarding.subtitle") }}</template>
                      </Switcher>
                    </div>
                    <!-- research -->
                    <div class="mt-2">
                      <Switcher v-model="settings.research" :padding="'p-0'" @input="updateInfo('email')">
                        <template #title>{{ $t("accountSettings.email.research.title") }}</template>
                        <template #subtitle>{{ $t("accountSettings.email.research.subtitle") }}</template>
                      </Switcher>
                    </div>
                    <!-- analytics -->
                    <div class="mt-2">
                      <Switcher v-model="settings.analytics" :padding="'p-0'" @input="updateInfo('email')">
                        <template #title>{{ $t("accountSettings.email.analytics.title") }}</template>
                        <template #subtitle>{{ $t("accountSettings.email.analytics.subtitle") }}</template>
                      </Switcher>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>

        <section id="data_privacy" class="mb-4">
          <div class="gp-card data-privacy">
            <div class="gp-card__head">
              <h3 class="gp-card__head-title">{{ $t("accountSettings.dataPrivacy.title") }}</h3>
            </div>
            <div class="gp-card__body">
              <div class="block flex align-items-center cookie-setting">
                <div class="cookie-setting__left">
                  <p class="typo-paragraph14 typo-medium text-lightmode mb-1">
                    {{ $t("accountSettings.dataPrivacy.privacyPreferences.title") }}
                  </p>
                  <p class="typo-body4 typo-regular text-light-low" v-html="$t('accountSettings.dataPrivacy.privacyPreferences.subtitle')"></p>
                </div>
                <div class="cookie-setting__right">
                  <button type="button" class="btn ml-0 btn-secondary2 cky-banner-element">
                    {{ $t("accountSettings.dataPrivacy.privacyPreferences.button.title") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section v-if="!isGemPagesV7" id="add_code_to_theme" class="mb-4">
          <div class="gp-card add-code-to-theme">
            <div class="gp-card__head">
              <h3 class="gp-card__head-title">{{ $t("accountSettings.addCodeToTheme.title") }}</h3>
            </div>
            <div class="gp-card__body">
              <div class="form-group">
                <label class="label d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center">
                    <span>{{ $t("accountSettings.addCodeToTheme.addForHead") }}</span>
                    <div class="pr-1 ml-1 mr-1 d-flex" v-popover:mytooltip.right="$t('accountSettings.addCodeToTheme.addForHeadTooltip')">
                      <i class="icon icon-help tip typo-icon-14 text-light-disabled"></i>
                    </div>
                  </div>
                  <span class="reset-code" :class="{ disabled: !isChangeCustomCodeHead }" @click="onResetCode('head')">{{ $t("accountSettings.addCodeToTheme.resetCode") }}</span>
                </label>
                <textarea v-model="scriptInjector.headScript" id="" class="custom-code" cols="30" rows="10"></textarea>
                <div class="script-url my-1" v-html="$t('accountSettings.addCodeToTheme.addForHeadUrl', { href: scriptInjector.headScriptActivationUrl })"></div>
              </div>
              <div class="form-group mt-2">
                <label class="label d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center">
                    <span>{{ $t("accountSettings.addCodeToTheme.addForBody") }}</span>
                    <div class="pr-1 ml-1 mr-1 d-flex" v-popover:mytooltip.right="$t('accountSettings.addCodeToTheme.addForBodyTooltip')">
                      <i class="icon icon-help tip typo-icon-14 text-light-disabled"></i>
                    </div>
                  </div>
                  <span class="reset-code" :class="{ disabled: !isChangeCustomCodeBody }" @click="onResetCode('body')">{{ $t("accountSettings.addCodeToTheme.resetCode") }}</span>
                </label>
                <textarea v-model="scriptInjector.bodyScript" id="" class="custom-code" cols="30" rows="10"></textarea>
                <div class="script-url my-1" v-html="$t('accountSettings.addCodeToTheme.addForBodyUrl', { href: scriptInjector.bodyScriptActivationUrl })"></div>
              </div>
            </div>
            <div class="gp-card__footer mt-2 d-flex justify-content-end">
              <button :disabled="!isChangeCustomCodeHead && !isChangeCustomCodeBody" class="btn btn-secondary2 btn-save-code" @click="onSaveCodeToTheme">{{ $t("accountSettings.addCodeToTheme.save") }}</button>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
import SelectLang from "@/core/shared/GpForms/components/SelectLang.vue";
import { ProcessButton } from "@/core/shared";
import { mapState, mapActions, mapMutations } from "vuex";
import { actions } from "@/store/account/types";
import errorHandle from "@/mixins/errorHandle.js";
import Switcher from "@/core/shared/essenstials/Switcher.vue";
import WebAnalyticTools from "../components/WebAnalyticTools.vue";
import dynamicTriggerContent from "@/mixins/dynamicTriggerContent";
import { PLAN_NO, PLAN_NAMES } from "@/contants/plan";

export default {
  name: "AccountSettings",
  components: {
    SelectLang,
    ProcessButton,
    Switcher,
    WebAnalyticTools
  },
  mixins: [errorHandle(), dynamicTriggerContent()],
  data() {
    return {
      prevRoute: null,
      firstName: "",
      lastName: "",
      email: "",
      lang: "en",
      lazyLoading: false,
      refID: "",
      modalActive: false,
      storePassword: "",
      cacheStorePassword: "",
      showPassword: false,
      wrongPassword: false,
      settings: {
        newsletters: true,
        updates: true,
        partners: true,
        onboarding: true,
        research: true,
        analytics: true,
        schedulePublish: true,
        theme: true
      },
      storeSettings: {
        productSchema: false,
        lazyload: false,
        themeScript: false,
        preloadScript: false
      },
      highlight: {
        ga: false
      },
      analytics: {
        ga: {
          active: false,
          gaAccountId: "",
          gaPropertyId: "",
          gaViewId: "",
          gaType: ""
        }
      },
      activeMenu: "store_settings",
      isLoading: false,
      scriptInjector: {
        headScript: "",
        headScriptActivationUrl: "",
        bodyScript: "",
        bodyScriptActivationUrl: ""
      },
      PLAN_NO,
      PLAN_NAMES
    };
  },
  computed: {
    ...mapState("account", {
      status: state => state.status,
      shopInfo: state => state.shopInfo,
      unlinkStatus: state => state.unlinkStatus,
      hideLanguage: state => state.hideLanguage
    }),
    ...mapState("agency", {
      agencyLogged: state => state.logged
    }),

    shopPlan() {
      if (this.shopInfo.plan == "plus") return "shopify plus";

      if (PLAN_NAMES[this.shopInfo.plan]) {
        return PLAN_NAMES[this.shopInfo.plan];
      }
      let str = this.shopInfo.plan.charAt(0).toUpperCase() + this.shopInfo.plan.slice(1);
      return str;
    },
    isTrial() {
      return this.shopInfo.plan === PLAN_NO.TRIAL2022 || this.shopInfo.plan === PLAN_NO.TRIAL;
    },
    shouldShowWarningBox() {
      const keyThatNotAllowedToBeFalse = ["theme"];
      let errCount = keyThatNotAllowedToBeFalse.reduce((cummulative, value) => {
        if (this.settings[value] == false) {
          cummulative++;
        }
        return cummulative;
      }, 0);
      return errCount > 0;
    },
    shouldDisableAnalyticSubmitAction() {
      if (!this.shopInfo.gaLoggedIn) {
        return false;
      }
      const accountID = this.analytics.ga.gaAccountId;
      const propertyID = this.analytics.ga.gaPropertyId;
      return accountID != "" && (!propertyID || propertyID == "");
    },
    statusLoading() {
      if (this.isLoading) {
        return this.status;
      }
      return { loading: false, error: null, success: null };
    },
    changePassword() {
      return this.cacheStorePassword === this.storePassword ? true : false;
    },
    isChangeCustomCodeHead() {
      return this.scriptInjector.headScript != this.shopInfo.scriptInjector?.headScript;
    },
    isChangeCustomCodeBody() {
      return this.scriptInjector.bodyScript != this.shopInfo.scriptInjector?.bodyScript;
    },
    isGemPagesV7() {
      return (this && this.shopInfo && this.shopInfo.shopType && this.shopInfo.shopType.isGemPagesV7) || window.___gemShopInfo.shopType.isGemPagesV7 || false;
    }
    // activeMenu() {
    //   console.log(111,this.isGemPagesV7)
    //   return this.isGemPagesV7 ? 'plan_information':'store_settings'
    // }
  },
  watch: {
    shopInfo(newV) {
      this.assignInfo(newV);
    },
    scriptInjector: {
      handler(newV) {
        const _this = this;
        if (newV.headScript != _this.shopInfo.scriptInjector?.headScript || newV.bodyScript != _this.shopInfo.scriptInjector?.bodyScript) {
          window.onbeforeunload = () => {
            return true;
          };
        } else {
          window.onbeforeunload = null;
        }
      },
      deep: true
    }
  },
  created() {
    this.assignInfo(this.shopInfo);
    if (this.$route.query && [1, "1"].includes(this.$route.query.highlightGA)) {
      this.highlight.ga = true;
    } else {
      this.highlight.ga = false;
    }
  },
  mounted() {
    if (!this.shopInfo.scriptInjector) {
      this.getAccountSettings().then(res => {
        this.assignAccountSettings(res.data);
      });
    }
    if (this.isGemPagesV7) {
      this.activeMenu = "plan_information";
    }
    this.handleScroll();
    this.getActiveSidebarMenu();
  },
  // beforeDestroy() {
  //   this.cancelChangeLanguage();
  // },
  methods: {
    ...mapActions("account", {
      updateShopInfo: actions.ACCOUNT_UPDATE_SHOP_INFO,
      unlinkAgency: actions.ACCOUNT_UNLINK_AGENCY,
      doChangeLanguage: actions.ACCOUNT_CHANGE_LANGUAGE,
      cancelChangeLanguage: actions.ACCOUNT_CANCEL_CHANGE_LANGUAGE,
      updateStoreInfo: actions.ACCOUNT_UPDATE_STORE_INFO,
      updateScriptInjector: actions.ACCOUNT_UPDATE_SCRIPT_INJECTION,
      getAccountSettings: actions.ACCOUNT_SETTINGS
    }),
    // ...mapMutations("account", {
    //   doChangeLanguage: "ACCOUNT_CHANGE_LANGUAGE",
    //   cancelChangeLanguage: "ACCOUNT_CANCEL_CHANGE_LANGUAGE",
    // }),
    changeLang() {
      // this.doChangeLanguage(val);
      this.updateInfo();
    },
    getActiveSidebarMenu() {
      let hash = this.$route.hash || "";
      hash = (hash && hash.replace("#", "")) || "";
      if (hash) {
        this.scrollTo(hash);
      }
    },
    handleScroll() {
      const _this = this;
      const body = document.getElementById("mainBody");
      if (body) {
        body.onscroll = () => {
          const scrollY = body.scrollTop;
          const sections = document.querySelectorAll("section[id]");
          sections.forEach(current => {
            const sectionHeight = current.offsetHeight;
            const sectionTop = current.offsetTop - 148;
            const sectionId = current.getAttribute("id");
            if (scrollY <= 128) {
              this.activeMenu = _this.isGemPagesV7 ? "plan_information" : "store_settings";
            } else if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
              this.activeMenu = sectionId;
            }
          });
        };
      }
    },
    scrollTo(elId) {
      this.$nextTick(() => {
        this.activeMenu = "";
        const el = document.getElementById(elId);
        const body = document.getElementById("mainBody");
        if (el) {
          // el.scrollIntoView();
          const yOffset = -115;
          const offsetTop = el.offsetTop;
          const y = offsetTop + yOffset;
          body.scrollTo({ top: y, behavior: "smooth" });
          this.activeMenu = elId;
          this.$forceUpdate();
        }
      });
    },
    logValue(val) {
      console.log(val);
      this.updateInfo("analytics");
    },
    goToUpgrade() {
      this.$router.push({
        name: "Pricing",
        query: {
          from: this.dynamicTrigger.see_plan
        }
      });
    },
    ...mapMutations({}),
    cancel() {
      // this.cancelChangeLanguage();
      if (this.prevRoute.name != null) this.$router.go(-1);
      else this.$router.push({ name: "Dashboard" });
    },
    assignAccountSettings(data) {
      if (data?.scriptInjector) {
        this.scriptInjector = { ...data.scriptInjector };
      }
    },
    assignInfo(shopInfo) {
      this.firstName = shopInfo.firstName;
      this.lastName = shopInfo.lastName;
      this.email = shopInfo.email;
      this.lang = shopInfo.language.toLowerCase();
      if (shopInfo.shareable) {
        this.refID = shopInfo.ref;
      }
      if (shopInfo?.accountInfo?.emailPreferences) {
        this.settings = {
          ...this.settings,
          ...(shopInfo.accountInfo.emailPreferences || {})
        };
      }
      if (shopInfo?.accountInfo?.webAnalyticsTools) {
        this.analytics.ga = {
          ...this.analytics.ga,
          active: this.shopInfo.gaLoggedIn,
          ...(shopInfo?.accountInfo?.webAnalyticsTools?.ga || {})
        };
      }
      this.storePassword = shopInfo.password || "";
      this.cacheStorePassword = shopInfo.password || "";
      if (shopInfo?.storeInfo) {
        this.storeSettings = {
          ...this.storeSettings,
          ...shopInfo.storeInfo
        };
      }
    },
    async updateStoreSettings(isLoading = false) {
      this.isLoading = isLoading;
      try {
        this.gSnackbarCommit({
          message: this.$t("status.processing"),
          type: "loading"
        });
        await this.updateStoreInfo({
          data: {
            password: this.storePassword,
            productSchema: this.storeSettings.productSchema,
            themeScript: this.storeSettings.themeScript,
            preloadScript: this.storeSettings.preloadScript,
            type: "store"
          }
        });
        this.gSnackbarCommit({
          message: this.$t("accountSettings.status.success"),
          type: "success"
        });
      } catch (error) {
        this.cancelChangeLanguage();
        const message = error?.response?.data?.message || "Error";
        this.gSnackbarCommit({
          message: this.getErrorMessage(message),
          type: "error"
        });
      }
    },
    updateInfo(section) {
      let data = {
        profile: {
          // firstName: this.firstName,
          // lastName: this.lastName,
          // email: this.email,
          language: this.lang,
          ref: this.refID,
          plan: "trial",
          type: "account"
        },
        emailPreferences: this.settings
      };
      if (section == "email") {
        this.emailPreferences = this.settings;
      }
      if (section == "analytics") {
        if (this.shouldDisableAnalyticSubmitAction) {
          return;
        }
        data = {
          ...data,
          webAnalyticsTools: {
            ga: {
              gaType: this.analytics?.ga?.gaType || "",
              gaAccountId: this.analytics?.ga?.gaAccountId || "",
              gaPropertyId: this.analytics?.ga?.gaPropertyId || "",
              gaViewId: this.analytics?.ga?.gaViewId || ""
            }
          }
        };
        // this.webAnalyticsTools = this.analytics;
        // delete data.webAnalyticsTools?.ga?.active;
      }
      this.doChangeLanguage(this.lang);
      this.gSnackbarCommit({
        message: this.$t("status.processing"),
        type: "loading"
      });
      this.updateShopInfo({
        data: data,
        onSuccess: () => {
          this.gSnackbarCommit({
            message: this.$t("accountSettings.status.success"),
            type: "success"
          });
        },
        onError: err => {
          this.cancelChangeLanguage();
          this.gSnackbarCommit({
            message: err.msg,
            type: "error"
          });
        }
      });
    },
    showModalUnlink() {
      this.modalActive = true;
    },
    closeModal() {
      this.modalActive = false;
    },
    doUnlink() {
      this.unlinkAgency()
        .then(() => {
          this.gSnackbarCommit({
            message: this.$t("accountSettings.status.success"),
            type: "success"
          });
        })
        .catch(err => {
          let message = this.getErrorMessage(err);
          this.gSnackbarCommit({
            message,
            type: "error"
          });
        });
    },
    async onSaveCodeToTheme() {
      try {
        this.gSnackbarCommit({
          message: this.$t("status.processing"),
          type: "loading"
        });
        await this.updateScriptInjector(this.scriptInjector);
        this.gSnackbarCommit({
          message: this.$t("accountSettings.status.success"),
          type: "success"
        });
        window.onbeforeunload = null;
      } catch (error) {
        const message = error?.response?.data?.message || "Error";
        this.gSnackbarCommit({
          message: this.getErrorMessage(message),
          type: "error"
        });
      }
    },
    onResetCode(type) {
      if (type == "head") {
        this.scriptInjector.headScript = this.shopInfo.scriptInjector?.headScript;
      } else {
        this.scriptInjector.bodyScript = this.shopInfo.scriptInjector?.bodyScript;
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },
  beforeRouteLeave(to, from, next) {
    if (this.isChangeCustomCodeHead || this.isChangeCustomCodeBody) {
      if (window.confirm("Are you sure you want to leave?")) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  }
};
</script>

<style lang="scss" scoped>
.data-privacy {
  @media (min-width: 1024px) {
    padding-bottom: 400px;
  }
  @media (min-width: 1600px) {
    padding-bottom: 460px;
  }
  @media (min-width: 1920px) {
    padding-bottom: 660px;
  }
}
input {
  border-radius: 3px;
}
.password-field {
  .password-field-input {
    flex: 1;
    position: relative;
  }
  .input-field {
    width: 100%;
    height: 40px;
  }
}
.gp-main-body-content__line {
  border-top: 1px solid $textDarkModeHigh;
}
.gt-line {
  border-top: 1px solid $textDarkModeHigh;
  margin: 16px 0;
}
button {
  height: 40px;
  min-width: 160px;
  &.disabled,
  &:disabled {
    color: $textDarkModeDisabled;
    background: $dark3;
    cursor: no-drop;
  }
}
button.disabled,
button:disabled {
  .square-google {
    opacity: 0.4;
  }
}
.gp-settings-page {
  display: flex;
  .gp_dropdown {
    border: 1px solid $textDarkModeHigh;
    border-radius: 3px;
  }
  .input-field {
    border: solid 1px $neutral7;
    &:focus {
      border-color: $mono3;
    }
  }
  .shop-info {
    border-radius: 3px;
    background-color: $light2;
    .link {
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .warn-info {
    background-color: #fffae6;
    border-radius: 3px;
    .icon {
      color: $cYellow3;
    }
  }
  .data-privacy {
    .cookie-setting {
      display: flex;
      align-items: center;
      .cookie-setting__left {
        flex: 1;
      }
      .cookie-setting__right {
        width: 160px;
        margin-left: 16px;
        button {
          width: 100%;
        }
      }
    }
  }
  .gp-card {
    background-color: #fff;
    border-radius: 3px;
    padding: 0 16px;
    .gp-card__head {
      padding-bottom: 16px;
      .gp-card__head-title {
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
        color: $textLightModeHigh;
      }
    }
    .gp-card__body {
      padding: 16px;
      border-radius: 3px;
      border: solid 1px $light3;
    }
  }
  .gp-settings-page__sidebar {
    width: 180px;
    @media (max-width: 768px) {
      display: none;
    }
    .gp-settings-page__sidebar-nav {
      position: fixed;
      top: 0;
      list-style: none;
      top: 196px;
      li {
        a {
          display: flex;
          align-items: center;
          width: 100%;
          padding: 9px 0;
          font-style: normal;
          font-weight: 500;
          font-size: 14px;
          line-height: 150%;
          color: $textLightModeLow;
          &:hover,
          &.active {
            color: $mono4;
          }
        }
        &:first-child {
          a {
            padding-top: 0;
          }
        }
      }
    }
  }
  .gp-settings-page__content {
    flex: 1;
    margin-left: 24px;
    @media (max-width: 768px) {
      margin-left: 0;
    }
  }
}
.script-url {
  font-size: 12px;
  line-height: 150%;
  color: $dark6;
}
.reset-code {
  font-size: 12px;
  color: $cPrimary;
  cursor: pointer;

  &.disabled {
    color: #9e9e9e;
    pointer-events: none;
  }
}
.btn-save-code {
  border-radius: 3px;
  padding: 8px 24px;
  font-size: 14px;
  line-height: 16px;
}
.tool-tip-custom-code {
  border-radius: 4px;
  left: -120px;
  width: 254px;
}
.tool-tip-value {
  font-size: 12px;
}
.tool-tip::after {
  left: 50%;
}
.custom-code {
  border-radius: 3px;
  border: 1px solid $neutral7;
  resize: vertical;
}
.image-wrapper {
  // width: 42px;
  height: 42px;
  display: flex;
  // // align-items: center;
  // justify-content: center;
  .advanced {
    width: 24px;
    height: 28px;
  }
  .trial,
  .trial2022,
  .optimize {
    width: 24px;
    height: 28px;
  }
  .professional {
    width: 24px;
    height: 24px;
    margin-top: 4px;
  }
  .starter {
    width: 28px;
    height: 24px;
    margin-top: 4px;
  }
  .build {
    width: 28px;
    height: 28px;
  }
  .enterprise {
    width: 32px;
    height: 24px;
    margin-top: 4px;
  }
}
</style>
